
import { BoxManagementDocumentPage } from './document.box';
import { CloudManagementDocumentPage } from './document.cloud';
import { DemoManagementDocumentPage } from './document.demo';

import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

export default class ManagementEdit extends mixin(environment.nexus, {
    box: BoxManagementDocumentPage,
    cloud: CloudManagementDocumentPage,
    demo: DemoManagementDocumentPage
}) { }
